// InboxScreen.js
import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';

var MESSAGES = [
  { id: '1', from: 'Dr. Martinez', subj: 'Great progress this week!', time: '2h ago', read: false, body: 'I noticed you completed all quests for 4 days straight. Keep it up!' },
  { id: '2', from: 'Momentum Team', subj: 'New milestone unlocked!', time: '1d ago', read: false, body: 'Congratulations! You reached the 7-day mark. A new reward tier is available.' },
  { id: '3', from: 'Dr. Martinez', subj: 'Upcoming appointment reminder', time: '2d ago', read: true, body: 'Reminder: your next check-in is Feb 3rd at 10:00 AM.' },
  { id: '4', from: 'Momentum Team', subj: 'Welcome to Momentum!', time: '5d ago', read: true, body: 'We are thrilled to have you on board.' },
];

export default function InboxScreen({ navigation }) {
  var selState = useState(null);
  var selected = selState[0];
  var setSelected = selState[1];

  return (
    <View style={s.container}>
      <SafeAreaView style={s.safe}>
        <View style={s.header}>
          <TouchableOpacity onPress={function() { if (selected) { setSelected(null); } else { navigation.goBack(); } }}>
            <Icon name="chevron-back" size={24} color={Colors.primary} />
          </TouchableOpacity>
          <Text style={s.title}>Inbox</Text>
          <View style={{ width: 24 }} />
        </View>
        <ScrollView contentContainerStyle={s.content}>
          {selected ? (
            <View style={s.msgDetail}>
              <Text style={s.msgSubj}>{selected.subj}</Text>
              <Text style={s.msgMeta}>{'From: ' + selected.from + ' · ' + selected.time}</Text>
              <Text style={s.msgBody}>{selected.body}</Text>
            </View>
          ) : (
            MESSAGES.map(function(m) {
              return (
                <TouchableOpacity key={m.id} style={[s.msgRow, !m.read && s.msgUnread]} onPress={function() { setSelected(m); }}>
                  <View style={[s.msgAvatar, { backgroundColor: m.from.includes('Team') ? Colors.primary : Colors.coral }]}>
                    <Text style={s.msgAvatarText}>{m.from[0]}</Text>
                  </View>
                  <View style={s.msgContent}>
                    <View style={s.msgTopRow}>
                      <Text style={[s.msgFrom, !m.read && { fontWeight: '700' }]}>{m.from}</Text>
                      <Text style={s.msgTime}>{m.time}</Text>
                    </View>
                    <Text style={s.msgSubjPreview} numberOfLines={1}>{m.subj}</Text>
                  </View>
                </TouchableOpacity>
              );
            })
          )}
        </ScrollView>
      </SafeAreaView>
    </View>
  );
}

var s = StyleSheet.create({
  container: { flex: 1, backgroundColor: Colors.bgTop },
  safe: { flex: 1 },
  header: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 16, paddingVertical: 12 },
  title: { fontSize: 20, fontWeight: '700', color: Colors.textDark },
  content: { padding: 20 },
  msgRow: { flexDirection: 'row', alignItems: 'flex-start', gap: 12, padding: 14, backgroundColor: Colors.card, borderRadius: 14, marginBottom: 8 },
  msgUnread: { borderWidth: 1.5, borderColor: Colors.primary },
  msgAvatar: { width: 40, height: 40, borderRadius: 20, alignItems: 'center', justifyContent: 'center' },
  msgAvatarText: { color: '#fff', fontWeight: '700', fontSize: 16 },
  msgContent: { flex: 1 },
  msgTopRow: { flexDirection: 'row', justifyContent: 'space-between' },
  msgFrom: { fontSize: 14, color: Colors.textDark },
  msgTime: { fontSize: 11, color: Colors.textLight },
  msgSubjPreview: { fontSize: 13, color: Colors.textMid, marginTop: 3 },
  msgDetail: { backgroundColor: Colors.card, borderRadius: 14, padding: 18 },
  msgSubj: { fontSize: 16, fontWeight: '700', color: Colors.textDark, marginBottom: 4 },
  msgMeta: { fontSize: 12, color: Colors.textLight, marginBottom: 12 },
  msgBody: { fontSize: 14, color: Colors.textDark, lineHeight: 22 },
});
